
import React from 'react'
type Props = {
    loading: boolean,
    error: any,
    children : React.ReactNode,
    customLoaderComponent ?: any
}

const LoaderWrapper = ({loading, error, children, customLoaderComponent} : Props) => {
    if(loading){
        if(customLoaderComponent){
            return customLoaderComponent
        }
        else{
            return(
                <div className='w-full text-center p-4 '>
                    Loading ... 
                </div>
            )
        }
    }
    if(error){
        return (
            <div className='w-full text-center text-red-500'>
                ERROR OCCUERED : {error || " "}
            </div>
        )
    }
  return children
}

export default LoaderWrapper